import { Dialog, DialogActions, DialogContent, DialogTitle, Grid, Fab, FormControl, InputLabel, makeStyles, MenuItem, Select, 
    Typography } from '@material-ui/core';
import ExitIcon from '@material-ui/icons/Clear';
import React, { useState } from 'react';
import ReactPlayer from 'react-player';
import { globalStyles } from '../style/GlobalStyles';
import { Applicazioni } from '../types/types';
import { IGlobalState } from '../states/GlobalState';
import { useGlobal } from 'reactn';

const useStyles = makeStyles({
    root: {
        display: 'flex',
        flexDirection: 'column'
    },
    dialog: {
        height: 'auto',
        width: 'auto'
        // maxHeight: '100vh',
        // maxWidth: '100vw'
    },
    playerWrapper: {
        position: 'relative',
        paddingTop: '1%' /* Player ratio: 100 / (1280 / 720) */
    },
    reactPlayer: {
        position: 'absolute',
        top: 0,
        left: 0,
    }
});

export type CaricaModalProps = {
    isOpen: boolean;
    handleClose: any;
    handleLoad: any;
    handleDelete: any;
    // applicazione: number;
}

export default function VideoTutorial(props: CaricaModalProps) {
    const classes = useStyles();
    const gClasses = globalStyles();
    const [application,] = useGlobal<IGlobalState, 'application'>('application');
    const [urlVideo,setUrlVideo] = useState(application === Applicazioni.iForfettari ? '/Tutorial Forf_1.mp4' : application === Applicazioni.ConvSrl ? '/Tutorial CONVSRL_1.mp4' : '/Tutorial BUDGET4U_1.mp4'); 
    
    const selectVideoTutorial = (value: any) => {
        // const valore = e as string;
        console.log('applicazione Dialog is: ' + application);
        console.log({value});
        
        switch (value) {
            case '1':
                if (application === Applicazioni.iForfettari) {
                    setUrlVideo('/Tutorial Forf_1.mp4');
                } else if (application === Applicazioni.ConvSrl) {
                    setUrlVideo('/Tutorial CONVSRL_1.mp4');
                } else if (application === Applicazioni.Budget4u) {
                    setUrlVideo('/Tutorial BUDGET4U_1.mp4');
                }
                break;

            case '2':
                if (application === Applicazioni.iForfettari) {
                    setUrlVideo('/Tutorial Forf_2.mp4');
                } else if (application === Applicazioni.ConvSrl) {
                    setUrlVideo('/Tutorial CONVSRL_2.mp4');
                } else if (application === Applicazioni.Budget4u) {
                    setUrlVideo('/Tutorial BUDGET4U_2.mp4');
                }
                break;
            
            case '3':
                if (application === Applicazioni.iForfettari) {
                    setUrlVideo('/Tutorial Forf_3.mp4');
                } else if (application === Applicazioni.ConvSrl) {
                    setUrlVideo('/Tutorial CONVSRL_3.mp4');
                } else if (application === Applicazioni.Budget4u) {
                    setUrlVideo('/Tutorial BUDGET4U_3.mp4');
                }
                break;
            
            case '4':
                setUrlVideo('/Tutorial Navigazione.mp4');
                break;

            case '5':
                setUrlVideo('/Tutorial Utenti.mp4');
                break;
            
            case '6':
                setUrlVideo('/Tutorial telematico.mp4');
                break;

            case '7':
                if (application === Applicazioni.iForfettari) {
                    setUrlVideo('/Tutorial load forfetari.mp4');
                } else if (application === Applicazioni.ConvSrl) {
                    setUrlVideo('/Tutorial load convenienza.mp4');
                }
                break;

            default:
                break;
        }

    }

    const handleChangeSelectVideo = (e: any) => {
        let { name, value } = e.target;               
        selectVideoTutorial(value);
    }
    
    React.useEffect(() => {
        // console.log('applicazione effect is: ' + props.applicazione);
        if (application === Applicazioni.iForfettari) {
            setUrlVideo('/Tutorial Forf_1.mp4');
        } else if (application === Applicazioni.ConvSrl) {
            setUrlVideo('/Tutorial CONVSRL_1.mp4');
        } else if (application === Applicazioni.Budget4u) {
            setUrlVideo('/Tutorial BUDGET4U_1.mp4');
        } else if (application === Applicazioni.Principal) {
            setUrlVideo('/Tutorial Utenti.mp4');
        } else if (application === Applicazioni.ImportTelematico) {
            setUrlVideo('/Tutorial telematico.mp4');
        }
    }, 
    // eslint-disable-next-line
    [application]);

    return (
        <div className={classes.root}>
            <Dialog
                open={props.isOpen}
                aria-labelledby="alert-dialog-title"
                // aria-describedby="alert-dialog-description"
                maxWidth="lg"
                fullScreen={false}
                fullWidth={false}
            >
                <DialogTitle id="alert-dialog-title" style={{textAlign: 'center'}}>{<Typography variant="h5" color="primary">Video Tutorial</Typography>}</DialogTitle>
                <DialogContent dividers>
                    <React.Fragment>
                        <div className={classes.dialog}>
                            <Grid container direction="column">
                                <Grid item xs={12} style={{textAlign: 'center'}}>
                                    <FormControl>
                                        <InputLabel htmlFor="tutorial" style={{marginLeft: '20%'}}>Seleziona tutorial</InputLabel>
                                        {application < Applicazioni.Budget4u ? 
                                        <>
                                        <Select
                                            className={gClasses.select}
                                            // value={state.tipologia}
                                            onChange={handleChangeSelectVideo}
                                            // onChange={handleChange}
                                            inputProps={{
                                                name: 'tutorial',
                                                id: 'tutorial',
                                            }}
                                            defaultValue='1'
                                        >
                                            <MenuItem value={"1"}>Tutorial parte 1</MenuItem>
                                            <MenuItem value={"2"}>Tutorial parte 2</MenuItem>
                                            <MenuItem value={"3"}>Tutorial parte 3</MenuItem>
                                            <MenuItem value={"4"}>Tutorial navigazione</MenuItem>
                                            <MenuItem value={"7"}>Tutorial load telematico</MenuItem>
                                        </Select>
                                        </>
                                        :
                                        application === Applicazioni.Budget4u ?
                                        <>
                                        <Select
                                            className={gClasses.select}
                                            // value={state.tipologia}
                                            onChange={handleChangeSelectVideo}
                                            // onChange={handleChange}
                                            inputProps={{
                                                name: 'tutorial',
                                                id: 'tutorial',
                                            }}
                                            defaultValue='1'
                                        >
                                            <MenuItem value={"1"}>Tutorial parte 1</MenuItem>
                                            <MenuItem value={"2"}>Tutorial parte 2</MenuItem>
                                            <MenuItem value={"3"}>Tutorial parte 3</MenuItem>
                                            <MenuItem value={"4"}>Tutorial navigazione</MenuItem>
                                        </Select>
                                        </>
                                        :
                                        application === Applicazioni.Principal ?
                                        <>
                                        <Select
                                            className={gClasses.select}
                                            // value={state.tipologia}
                                            onChange={handleChangeSelectVideo}
                                            // onChange={handleChange}
                                            inputProps={{
                                                name: 'tutorial',
                                                id: 'tutorial',
                                            }}
                                            defaultValue='5'
                                        >
                                            <MenuItem value={"5"}>Tutorial utenti</MenuItem>
                                        </Select>
                                        </>
                                        : 
                                        application === Applicazioni.ImportTelematico ?
                                        <>
                                        <Select
                                            className={gClasses.select}
                                            // value={state.tipologia}
                                            onChange={handleChangeSelectVideo}
                                            // onChange={handleChange}
                                            inputProps={{
                                                name: 'tutorial',
                                                id: 'tutorial',
                                            }}
                                            defaultValue='6'
                                        >
                                            <MenuItem value={"6"}>Tutorial telematico</MenuItem>
                                        </Select>
                                        </>
                                        : null
                                        }
                                    </FormControl>
                                </Grid>
                                <Grid item xs={12}>
                                    <ReactPlayer    
                                        // className={classes.reactPlayer}
                                        playsInline
                                        controls={true}
                                        // poster="/assets/poster.png"                                        
                                        // id="idPlayer" 
                                        url={urlVideo}
                                        playing={true}                               
                                        /*
                                        url={[
                                            {src: '/Tutorial Forf_1.mp4', type: 'video/mp4'},
                                            {src: '/Tutorial Forf_2.mp4', type: 'video/mp4'},
                                            {src: '/Tutorial Forf_3.mp4', type: 'video/mp4'},
                                            {src: '/Tutorial Navigazione.mp4', type: 'video/mp4'},
                                        ]}
                                        */
                                        width="900px"                               
                                        height="100%"                               
                                    />
                                </Grid>
                            </Grid>
                        </div>
                    </React.Fragment>
                </DialogContent>
                <DialogActions>
                    <Fab onClick={props.handleClose}>
                        <ExitIcon style={{ width: '2rem', height: '2rem' }} color="secondary" titleAccess="Chiudi" />
                    </Fab>
                </DialogActions>
            </Dialog>
            {/* <ModalVideo channel='custom' autoplay isOpen={isOpenModalVideo} url={urlVideo} onClose={() => setIsOpenModalVideo(false)} /> */}
        </div>
    );

}